/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

import {CHARTS_MARGIN_LEFT, CHARTS_MARGIN_RIGHT} from '../../const';

interface BrushRootProps {
  top: string;
}

const Root = styled(Box)<BrushRootProps>(({top}) => ({
  width: `calc(100% - ${CHARTS_MARGIN_RIGHT + CHARTS_MARGIN_LEFT}px)`,
  position: 'absolute',
  left: CHARTS_MARGIN_LEFT,
  zIndex: 1,
  height: '48px',
  boxSizing: 'content-box',
  borderRadius: '12px',
  border: '1px solid #a5a6ab',
  background: 'rgba(121, 164, 254, 0.1)',
  '> *': {
    position: 'absolute',
    left: '0',
    top: '0',
    zIndex: 10,
  },
  top,
}));

export {Root as BrushRoot};
